export const appendHeaders = (existingHeaders, additionalHeaders) => {
    for (const [headerName, headerValue] of Object.entries(additionalHeaders)) {
        if (Array.isArray(existingHeaders)) {
            existingHeaders.push([headerName, headerValue]);
        }
        else if (typeof existingHeaders.set === 'function') {
            existingHeaders.set(headerName, headerValue);
        }
        else {
            // eslint-disable-next-line security/detect-object-injection
            existingHeaders[headerName] = headerValue;
        }
    }
};
export const addQueryParamsToUrl = (url, params) => {
    if (!url || typeof url !== 'string')
        return url;
    // can't just append to the url because it might already have a query string
    const urlObject = new URL(url);
    for (const [paramName, paramValue] of Object.entries(params)) {
        urlObject.searchParams.append(paramName, paramValue);
    }
    return urlObject.toString();
};
/**
 * Checks if API token or WAT token is pending (e.g., being generated)
 *
 * @param token - API token
 * @param wat - WAT token
 * @returns true if the token is pending
 */
export const isAuthTokenPending = (token, wat) => {
    return token === null || wat === null;
};
//# sourceMappingURL=helpers.js.map